import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { EmotionalSection } from './components/EmotionalSection';
import { SolutionSection } from './components/SolutionSection';
import { IncludesSection } from './components/IncludesSection';
import { BenefitsSection } from './components/BenefitsSection';
import { ObjectionsSection } from './components/ObjectionsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-cream font-sans text-forest selection:bg-terracotta/30" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <EmotionalSection data-id="element-4" />
        <SolutionSection data-id="element-5" />
        <IncludesSection data-id="element-6" />
        <BenefitsSection data-id="element-7" />
        <ObjectionsSection data-id="element-8" />
        <GuaranteeSection data-id="element-9" />
        <FinalCTA data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}